<div class="grid justify-content-end mt-28 mb-8">
  <div
    class="link typography typography-caption grey-500"
    (click)="cleanFilters()"
  >
    Сбросить все фильтры&nbsp;&nbsp;&nbsp;✕
  </div>
</div>
